import React, { Component, useEffect, useState, useRef } from "react";
import { Icon } from "@iconify/react";
import "../../../dist/assets/stylesheets/css/recordPatient.css";
import AnimateHeight from "react-animate-height";
import { patientsActions, fetchPatients } from "../../store/patients-slice";

import {
  checkDevice,
  getCalibrationVideos,
  getCalibrationVideoUrl,
  startRecording,
  stopRecording,
} from "../../util/recordingAPI";
import { deleteTrial, updateTrialDate } from "../../util/trialApi";
import { cancelCameraDownload } from "../../util/sessionTransfer";
import { normalizeTrialId } from "../../util/trialId";
import CalibrationSelection from "./CalibrationSelection";
import { getPatients } from "../../util/patientsApi";
import PatientSelection from "./PatientSelection";
import CalibrationViewModal from "./CalibrationViewModal";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { notificationActions } from "../../store/notification-slice";
import { IoIosArrowBack } from "react-icons/io";
import { useQuery, useSharedResolution } from "../SharedHooks";
import { useHistory } from "react-router-dom";
import RecordingPanel from "./RecordingPanel";
import NoDevicesFound from "./NoDevicesFound";
import ScanningDevicesSpinner from "./ScanningDevicesSpinner";
import AddNewPatientModal from "../patients/AddNewPatientModal";
import { usePiPresence } from "../../hooks/usePiPresence";
import { usePipelineVersion } from "../../hooks/usePipelineVersion";
import { isCalibrationUiEnabled } from "../../util/pipelineVersion";
function NewRecordingPage() {
  usePiPresence('record');
  // Pipeline 2.0 calibrates itself, so the page offers no calibration controls.
  const calibrationEnabled = isCalibrationUiEnabled(usePipelineVersion());
  const dispatch = useDispatch();
  const query = useQuery();
  const history = useHistory();
  const { resolution } = useSharedResolution();
  const [trials, setTrials] = useState([]);
  const [processingButtonState, setProcessingButtonState] = useState({
    isProcessing: false,
    downloadsComplete: false,
  });
  const downloadIntervalRef = useRef(null);
  const downloadGenerationRef = useRef(0);
  const localIdRef = useRef(0);
  const trialIdsRef = useRef({});
  const discardedRef = useRef(new Set());
  const [calibration, setCalibration] = useState({
    selected: localStorage.getItem("calibration") || null,
    open: false,
    data: null,
  });
  const patientsList = useSelector((state) => state.patients.patientsList);
  const [patient, setPatient] = useState({
    selected: query.get("selectedPatient") || false,
    open: false,
    data:patientsList||null
  });
  const [showNewPatientModal,setShowNewPatientModal]=useState(null)
  const [device,setDevice]=useState({
    finishedChecking:false,
    devicesFound:false,
  })
  const [calibrationView, setCalibrationView] = useState(null);
  useEffect(() => {
    checkDevice()
      .then((res) => {
        if (res.status != "success") {
          // alert(
          //   "No recording device detected on local network. Please check it is powered on and on the same wifi."
          // );
          setDevice({...device,devicesFound:false})
          return
        }
        setDevice({...device,devicesFound:true})
      })
      .catch((err) => {
        // alert(
        //   "No recording device detected on local network. Please check it is powered on and on the same wifi."
        // );
        setDevice({...device,devicesFound:false})
      }).finally(()=>setDevice({...device,finishedChecking:true}));
  }, []);
  useEffect(() => {
    if (calibrationEnabled) {
      getCalibrationVideos().then((res) =>
        setCalibration({ ...calibration, data: res.result })
      );
    }
    // getPatients().then((res) => setPatient({ ...patient, data: res }));
    dispatch(fetchPatients());
  }, [calibrationEnabled]);
  useEffect(()=>{
    setPatient({...patient,data:patientsList})
  },[patientsList])
  const selectCalibration = (selectedCalibration) => {
    localStorage.setItem("calibration", selectedCalibration);
    setCalibration({ ...calibration, selected: selectedCalibration });
  };
  const selectPatient = (id) => {
    history.push("?selectedPatient=" + id);
    setPatient({ ...patient, selected: id });
  };
  const selectCalibrationView = (id) => {
    getCalibrationVideoUrl(id)
      .then((res) =>
        setCalibrationView({ videos: res.result, calibration_id: id })
      )
      .catch((e) => {
        dispatch(
          notificationActions.setNotification({
            show: true,
            status: "error",
            message: e.response.data.reason,
          })
        );
      });
  };
  const processAllRecordings = () => {
    // If downloads are complete and button shows "Start new recording", refresh the page
    if (processingButtonState.downloadsComplete) {
      window.location.reload();
      return;
    }

    // Immediately grey out the button
    setProcessingButtonState({ isProcessing: true, downloadsComplete: false });
    const run = downloadGenerationRef.current + 1;
    downloadGenerationRef.current = run;

    // Initiate the finish-session API call
    const token = localStorage.getItem('token');
    const recorderHeaders = token ? { Authorization: 'Bearer ' + token } : {};
    fetch(window.RECORDING_URL + '/api/finish-session', { headers: recorderHeaders })
      .then(res => res.json())
      .then(res => {
        console.log(res);
        if (downloadGenerationRef.current !== run) return;
        
        // Get total cameras and start tracking download progress
        fetch(window.RECORDING_URL + '/api/total-cameras', { headers: recorderHeaders })
          .then(res => res.json())
          .then(data => {
            if (downloadGenerationRef.current !== run) return;
            const totalCameras = data.tot_cams;
            
            // Start polling for download progress
            downloadIntervalRef.current = setInterval(() => {
              fetch(window.RECORDING_URL + '/api/update-download', { headers: recorderHeaders })
                .then(response => response.json())
                .then(progress => {
                  if (downloadGenerationRef.current !== run) return;
                  const { downloaded } = progress;
                  
                  // Check if downloads are complete (including evowalk data)
                  // Assuming evowalk data downloads are included in the total cameras count
                  if (downloaded >= totalCameras) {
                    clearInterval(downloadIntervalRef.current);
                    setProcessingButtonState({ 
                      isProcessing: false, 
                      downloadsComplete: true 
                    });
                  }
                })
                .catch(error => {
                  console.error('Error fetching download progress:', error);
                  if (downloadGenerationRef.current !== run) return;
                  clearInterval(downloadIntervalRef.current);
                  setProcessingButtonState({ isProcessing: false, downloadsComplete: false });
                });
            }, 3000); // Poll every 3 seconds
          })
          .catch(err => {
            console.error('Error fetching total cameras:', err);
            if (downloadGenerationRef.current !== run) return;
            setProcessingButtonState({ isProcessing: false, downloadsComplete: false });
          });
      })
      .catch(err => {
        console.error('Error processing recordings:', err);
        if (downloadGenerationRef.current !== run) return;
        setProcessingButtonState({ isProcessing: false, downloadsComplete: false });
      });
  };

  // Cleanup interval on unmount
  useEffect(() => {
    return () => {
      if (downloadIntervalRef.current) {
        clearInterval(downloadIntervalRef.current);
      }
    };
  }, []);
  const reportDeleteFailure = (err) => {
    console.error('Failed to delete trial:', err);
    const data = err && err.response && err.response.data;
    dispatch(notificationActions.setNotification({
      show: true,
      status: 'error',
      message: (data && data.reason) || (err && err.message) || 'Unable to delete this trial. Please try again.',
    }));
  };
  const removeTrial = (localId) => {
    const trial = trials.find((row) => row.localId === localId);
    if (!trial || trial.isDeleting) return;
    discardedRef.current.add(localId);
    const id = trial.trialId != null ? String(trial.trialId) : trialIdsRef.current[localId];
    const dropCard = () => {
      setTrials((prev) => prev.filter((row) => row.localId !== localId));
    };
    if (id == null) {
      dropCard();
      return;
    }
    setTrials((prev) => prev.map((row) => (
      row.localId === localId ? { ...row, isDeleting: true } : row
    )));
    deleteTrial(id)
      .then(() => {
        const anotherFinished = trials.some((row) => (
          row.localId !== localId && row.finishedRecording
        ));
        if (!anotherFinished) {
          downloadGenerationRef.current += 1;
          if (downloadIntervalRef.current) {
            clearInterval(downloadIntervalRef.current);
            downloadIntervalRef.current = null;
          }
          setProcessingButtonState({ isProcessing: false, downloadsComplete: false });
          cancelCameraDownload();
        }
        dropCard();
      })
      .catch((err) => {
        discardedRef.current.delete(localId);
        setTrials((prev) => prev.map((row) => (
          row.localId === localId ? { ...row, isDeleting: false } : row
        )));
        reportDeleteFailure(err);
      });
  }
  const addNewTrial = () => {
    const localId = localIdRef.current;
    localIdRef.current += 1;
    let new_trial = {
      localId,
      assessment: "trial",
      calibrationID:calibration.selected,
      patientID:patient.selected,
      finishedRecording:false,
      isRecording:false,
      isLoading:false,
      res:resolution
    };

    setTrials([...trials, new_trial]);
  };
  const addNewPatient=()=>{
    setShowNewPatientModal(true)
  }
  const patchTrial = (localId, patch) => {
    setTrials((prev) => {
      if (!prev.some((row) => row.localId === localId)) return prev;
      return prev.map((row) => (row.localId === localId ? { ...row, ...patch } : row));
    });
  };
  const startRecord = (localId) => {
    const trial = trials.find((row) => row.localId === localId);
    if (!trial || trial.isLoading || trial.isRecording || discardedRef.current.has(localId)) return;
    patchTrial(localId, { isLoading: true });
    startRecording(trial.patientID, trial.res, trial.assessment, trial.calibrationID)
      .then(res => {
        const trialId = normalizeTrialId(res);
        if (trialId == null) {
          throw new Error('Start recording succeeded but no trial id was returned.');
        }
        trialIdsRef.current[localId] = trialId;
        if (discardedRef.current.has(localId)) {
          deleteTrial(trialId).catch(reportDeleteFailure);
          stopRecording().catch((err) => console.error('Error stopping discarded recording:', err));
          return;
        }
        patchTrial(localId, { isRecording: true, isLoading: false, trialId });
        updateTrialDate(trialId, new Date()).catch(err =>
          console.error('Failed to update trial date:', err)
        );
      })
      .catch(err => {
        console.error('Error starting recording:', err);
        const failedId = err && err.trialId ? String(err.trialId) : null;
        if (failedId) {
          trialIdsRef.current[localId] = failedId;
          deleteTrial(failedId).then(() => {
            delete trialIdsRef.current[localId];
          }).catch((deleteErr) => {
            if (discardedRef.current.has(localId)) {
              reportDeleteFailure(deleteErr);
              return;
            }
            console.error('Failed to delete trial:', deleteErr);
          });
        }
        if (discardedRef.current.has(localId)) return;
        patchTrial(localId, { isLoading: false, isRecording: false });
      });
  };

  const stopRecord = (localId) => {
    setTrials(currentTrials => {
      const index = currentTrials.findIndex((row) => row.localId === localId);
      const trial = index >= 0 ? currentTrials[index] : null;
      if (!trial || trial.isLoading || !trial.isRecording) {
        return currentTrials;
      }
      let copy = JSON.parse(JSON.stringify(currentTrials));
      copy[index].isLoading = true;
      stopRecording()
        .then(() => {
          patchTrial(localId, { isRecording: false, finishedRecording: true, isLoading: false });
        })
        .catch(err => {
          console.error('Error stopping recording:', err);
          patchTrial(localId, { isLoading: false });
        });
      return copy;
    });
  }
  // Lock page actions while waiting on start/stop RPi responses.
  const actionsLocked = trials.some((trial) => trial.isLoading);
  const setFinishRecording=(index)=>{
    console.log('done',index)
    let trials_copy=JSON.parse(JSON.stringify(trials))
    trials_copy[index]={...trials_copy,finishedRecording:true}
    setTrials(trials_copy)
  }

  // if (!device.finishedChecking) {
  //   return (<ScanningDevicesSpinner/>);
  // } else if (!device.devicesFound) {
  //   return (<NoDevicesFound/>);
  // }

  return (
    <div className="recordings-page parent-container">
      <nav className="container">
        <Link to="/recordings">
          <button className=" back-btn">
            <IoIosArrowBack />
            Recordings
          </button>
        </Link>
      </nav>
      <h1 className="page-title">New Recording</h1>
      <span className="page-sub-title">
        {calibrationEnabled
          ? 'Select calibration and patient to record a new trial.'
          : 'Select a patient to record a new trial.'}
      </span>
      {calibrationView?.videos && (
        <CalibrationViewModal
          handleClose={() => setCalibrationView(null)}
          data={calibrationView}
        />
      )}
      {showNewPatientModal&&<AddNewPatientModal handleClose={()=>setShowNewPatientModal(false)}/>}
      {calibrationEnabled && (
      <div className={`step-card-container${calibration.open ? ' open' : ''}${actionsLocked ? ' disabled' : ''}`}>
        <div
          className="step-card"
          role="button"
          tabIndex={actionsLocked ? -1 : 0}
          aria-expanded={calibration.open}
          aria-disabled={actionsLocked ? 'true' : undefined}
          aria-controls="new-recording-calibration-dropdown"
          onClick={() => {
            if (actionsLocked) return;
            setCalibration((prev) => ({ ...prev, open: !prev.open }));
          }}
          onKeyDown={(e) => {
            if (actionsLocked) return;
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setCalibration((prev) => ({ ...prev, open: !prev.open }));
            }
          }}
        >
          <div className="step-card-title-container">
            {calibration.selected ? (
              <Icon className="check" icon="ei:check" />
            ) : (
              <Icon icon="la:circle-solid" color="gray" />
            )}
            <h5>Select Calibration</h5>
            <span>
              {calibration.selected && calibration.data?.find((el) => el.id === calibration.selected)?.name}
            </span>
          </div>
          <Icon
            icon="iconamoon:arrow-up-2-light"
            className={calibration?.open ? 'open' : undefined}
          />
        </div>
        <AnimateHeight
          id="new-recording-calibration-dropdown"
          className="record-dropdown-animate-height"
          duration={420}
          height={calibration.open ? 'auto' : 0}
          easing="cubic-bezier(0.33, 1, 0.68, 1)"
          animateOpacity
        >
          <CalibrationSelection
            selectCalibration={selectCalibration}
            data={calibration.data}
            selectCalibrationView={selectCalibrationView}
            selected={calibration.selected}
          />
        </AnimateHeight>
      </div>
      )}
      <div className={`step-card-container${patient.open ? ' open' : ''}${actionsLocked ? ' disabled' : ''}`}>
        <div
          className="step-card"
          role="button"
          tabIndex={actionsLocked ? -1 : 0}
          aria-expanded={patient.open}
          aria-disabled={actionsLocked ? 'true' : undefined}
          aria-controls="new-recording-patient-dropdown"
          onClick={() => {
            if (actionsLocked) return;
            setPatient((prev) => ({ ...prev, open: !prev.open }));
          }}
          onKeyDown={(e) => {
            if (actionsLocked) return;
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setPatient((prev) => ({ ...prev, open: !prev.open }));
            }
          }}
        >
          <div className="step-card-title-container">
            {patient.selected ? (
              <Icon className="check" icon="ei:check" />
            ) : (
              <Icon icon="la:circle-solid" color="gray" />
            )}

            <h5>Select Patient</h5>
            <span>
              {patient.selected &&
                patient.data &&
                patient.data.find((el) => el.patient_id == patient.selected)
                  .patient_name}
            </span>
          </div>
          <Icon
            icon="iconamoon:arrow-up-2-light"
            className={patient?.open ? 'open' : undefined}
          />
        </div>
        <AnimateHeight
          id="new-recording-patient-dropdown"
          className="record-dropdown-animate-height"
          duration={420}
          height={patient.open ? 'auto' : 0}
          easing="cubic-bezier(0.33, 1, 0.68, 1)"
          animateOpacity
        >
          <PatientSelection
            selected={patient.selected}
            selectPatient={selectPatient}
            data={patient.data}
            addNewPatient={addNewPatient}
          />
        </AnimateHeight>
      </div>
      {(!calibrationEnabled || calibration.selected) && patient.selected && (
        <button
          onClick={addNewTrial}
          className="new-trial-btn svg-btn"
          style={{
            float: "right",
            opacity: actionsLocked ? 0.5 : 1,
            cursor: actionsLocked ? 'not-allowed' : 'pointer',
          }}
          disabled={actionsLocked}
        >
          <Icon icon="mingcute:add-fill" />
          New Trial
        </button>
      )}
      {trials.map((el) => (
        <RecordingPanel
          key={el.localId}
          trial={el}
          disabled={
            (actionsLocked && !el.isLoading) ||
            (trials.some(trial => trial.isRecording || trial.isLoading) && !el.isRecording && !el.isLoading)
          }
          startRecord={() => startRecord(el.localId)}
          stopRecord={() => stopRecord(el.localId)}
          removeTrial={() => removeTrial(el.localId)}
        />
      ))}
      {trials.length>0 && trials.every(trial=>trial.finishedRecording) && (
          <button 
            className={`process-recordings-btn ${processingButtonState.isProcessing || actionsLocked ? "disabled" : ""}`} 
            onClick={processAllRecordings}
            disabled={processingButtonState.isProcessing || actionsLocked}
          >
            {processingButtonState.downloadsComplete ? "Start new recording" : (processingButtonState.isProcessing ? "Uploading..." : "Upload to server")}
          </button>
      )}
    </div>);
}

export default NewRecordingPage;
